<template>
  <div class="container-custom">
    <!-- breadscrumbs -->
    <Breadscrumbs
      :links="[
        {
          name: 'HomePage',
          to: {
            name: 'HomePage'
          }
        },
        {
          name: 'Edit',
          to: {
            name: 'HomePageEdit',
            query: {
              section: $route.query.section,
            },
          }
        }
      ]"
    ></Breadscrumbs>
    <!-- page actions -->
    <div class="page-actions">
      <h2>編輯HomePage</h2>
      <v-spacer></v-spacer>
      <button class="btn mr-5" @click="cancelHandler">
        <span>取消</span>
      </button>
      <button class="btn btn-primary" @click="saveHandler">
        <span>儲存</span>
      </button>
    </div>
    <!-- block 1 -->
    <div class="block" style="min-height: 70vh; margin-bottom: 30px;">
      <PageMenu :sections="sections">
        <component :is="sectionView" :homepage="homepage"></component>
      </PageMenu>
    </div>
    <LangDialog :isOpen.sync="isLangOpen" @confirm-submit="saveHandler"></LangDialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import BrandVisual from '@/views/B-1__HomePage/c/B-1-2-1_HomePageEdit_BrandVisual.vue';
import BrandMessaging from '@/views/B-1__HomePage/c/B-1-2-2_HomePageEdit_BrandMessaging.vue';
import BuSections from '@/views/B-1__HomePage/c/B-1-2-3_HomePageEdit_BU_Sections.vue';
import PageMenu from '@/components/PageMenu.vue';
import LangDialog from '@/components/LangSubmitDialog.vue';
import Breadscrumbs from '@/components/Breadscrumbs.vue';

export default {
  components: {
    BrandVisual,
    BrandMessaging,
    BuSections,
    PageMenu,
    LangDialog,
    Breadscrumbs,
  },
  data: () => ({
    isLangOpen: false,
    sections: [
      {
        name: 'Brand Visual',
        component: 'BrandVisual',
      },
      {
        name: 'Brand Messaging',
        component: 'BrandMessaging',
      },
      {
        name: 'BU Sections',
        component: 'BuSections',
      },
    ],
  }),
  computed: {
    ...mapState(['lang']),
    ...mapState('homepage', ['homepage']),
    sectionIndex() {
      const vm = this;
      return vm.$route.query.section || 0;
    },
    sectionView() {
      const vm = this;
      return vm.sections[vm.sectionIndex].component;
    },
  },
  async created() {
    this.clear();
    await this.getHomepage();
  },
  methods: {
    ...mapActions('homepage', {
      getHomepage: 'find',
      clear: 'clear',
      save: 'save',
    }),
    toHomePage() {
      this.$router.push({
        name: 'HomePage',
        query: {
          section: this.$route.query.section,
        },
      });
    },
    cancelHandler() {
      this.toHomePage();
    },
    saveHandler() {
      if (this.isLangOpen || !this.lang.id) {
        this.save(this.homepage).then(() => {
          this.toHomePage();
        });
      } else {
        this.isLangOpen = true;
      }
    },
  },
};
</script>
<style></style>
